<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    isValid () {
      return true
    },
    isModified () {
      return false
    },
    getData () {
      return ''
    }
  }
}
</script>
